import c0 from './aluno_visibilidade_documentos_controller';
import c1 from './analise/filtros_controller';
import c2 from './analise/grafico_controller';
import c3 from './area_de_concentracao_controller';
import c4 from './biblioteca_controller';
import c5 from './centro_cursos_controller';
import c6 from './centro_laboratorios_controller';
import c7 from './centro_programas_controller';
import c8 from './conceitos_controller';
import c9 from './disable_submit_controller';
import c10 from './equivalencias_controller';
import c11 from './exclusive_checkbox_controller';
import c12 from './fotos_controller';
import c13 from './linha_de_pesquisa_controller';
import c14 from './matriz/escopo_controller';
import c15 from './matriz/grupo_controller';
import c16 from './matriz/periodo_controller';
import c17 from './matriz/proficiencias_controller';
import c18 from './plano_controller';
import c19 from './pre_matricula/alunos_controller';
import c20 from './redirect_controller';
import c21 from './remote_modal_controller';
import c22 from './requerimento_transferencia_de_turma_controller';
import c23 from './tracker_controller';
import c24 from './vacinacao_controller';
export const definitions = [
	{identifier: 'aluno-visibilidade-documentos', controllerConstructor: c0},
	{identifier: 'analise--filtros', controllerConstructor: c1},
	{identifier: 'analise--grafico', controllerConstructor: c2},
	{identifier: 'area-de-concentracao', controllerConstructor: c3},
	{identifier: 'biblioteca', controllerConstructor: c4},
	{identifier: 'centro-cursos', controllerConstructor: c5},
	{identifier: 'centro-laboratorios', controllerConstructor: c6},
	{identifier: 'centro-programas', controllerConstructor: c7},
	{identifier: 'conceitos', controllerConstructor: c8},
	{identifier: 'disable-submit', controllerConstructor: c9},
	{identifier: 'equivalencias', controllerConstructor: c10},
	{identifier: 'exclusive-checkbox', controllerConstructor: c11},
	{identifier: 'fotos', controllerConstructor: c12},
	{identifier: 'linha-de-pesquisa', controllerConstructor: c13},
	{identifier: 'matriz--escopo', controllerConstructor: c14},
	{identifier: 'matriz--grupo', controllerConstructor: c15},
	{identifier: 'matriz--periodo', controllerConstructor: c16},
	{identifier: 'matriz--proficiencias', controllerConstructor: c17},
	{identifier: 'plano', controllerConstructor: c18},
	{identifier: 'pre-matricula--alunos', controllerConstructor: c19},
	{identifier: 'redirect', controllerConstructor: c20},
	{identifier: 'remote-modal', controllerConstructor: c21},
	{identifier: 'requerimento-transferencia-de-turma', controllerConstructor: c22},
	{identifier: 'tracker', controllerConstructor: c23},
	{identifier: 'vacinacao', controllerConstructor: c24},
];
